export const VIDEO_PLAYER_KEYBOARD_CONFIG = {
  seekStep: 1.5,
  volumeStep: 5
}

